import styled from "styled-components";

const StyledMain= styled.main`
    display: flex;
    flex-direction: column;
    align-items: center;
`;
export {StyledMain}